var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.storeToken&&_vm.returnLabelArray.length>0)?_c('div',{staticClass:"goods_group_label_box"},[_vm._l((_vm.returnLabelArray),function(item,index){return [_c('el-tag',{style:(item.style),attrs:{"size":"mini","type":"error"}},[_vm._v(_vm._s(item.text))])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }